// test61
(61 && 0);
